import { Navigate, Route, Routes } from "react-router-dom";
import { BakeryCatalogProvider } from "./catalog/context/BakeryCatalogContext";
import CatalogLayout from "./catalog/layout/CatalogLayout";
import {
  ContactsCatalogRoutePage,
  HomeCatalogRoutePage,
  PartnersCatalogRoutePage,
  SetsCatalogRoutePage
} from "./catalog/pages/CatalogRoutePages";
import OrderPage from "./order/OrderPage";
import { BALDAI_ROUTE_PATHS } from "./routes";

export default function BaldaiRoutes() {
  return (
    <Routes>
      <Route path="order/:token" element={<OrderPage />} />
      <Route
        path={BALDAI_ROUTE_PATHS.home}
        element={
          <BakeryCatalogProvider>
            <CatalogLayout />
          </BakeryCatalogProvider>
        }
      >
        <Route index element={<HomeCatalogRoutePage />} />
        <Route path="sets" element={<SetsCatalogRoutePage />} />
        <Route path="partners" element={<PartnersCatalogRoutePage />} />
        <Route path="contacts" element={<ContactsCatalogRoutePage />} />
      </Route>
      <Route path="*" element={<Navigate to={BALDAI_ROUTE_PATHS.home} replace />} />
    </Routes>
  );
}
